import React from "react";
import PropTypes from "prop-types";
import { PrimaryButton, ButtonLink } from "../../../../components/Buttons";
import {
  W3Dropdown,
  W3DropdownToggler,
  W3DropdownContent,
} from "../../../../components/W3Dropdown";
import ActionFilter from "../ActionFilter";
import ConfirmationDialog from "../../../../components/ConfirmationDialog";
import { isDeletionTask } from "../Utils";

export default function DeviceTaskMenu({
  className = "",
  selectedDevices,
  filterDevices,
  closeDevices,
  deviceTaskType,
  items = [],
  exportDevices,
}) {
  const taskDialogRef = React.useRef(null);

  const onExport = React.useCallback(
    (event) => {
      if (event) event.preventDefault();
      let counter = 0;
      if (selectedDevices && selectedDevices.length > 0) {
        counter += selectedDevices.length;
      }
      taskDialogRef.current.show(
        true,
        {
          title: `Messgeräte exportieren`,
          text: `
          Alle ${counter} ausgewählte Messgeräte werden für die Weiterverarbeitung vorbereitet und als CSV exportiert.  
          Wollen Sie fortfahren?
        `,
        },
        () => exportDevices({ deviceTaskType }),
      );
    },
    [selectedDevices, exportDevices, deviceTaskType],
  );

  const onClose = React.useCallback(
    (event) => {
      if (event) event.preventDefault();
      let counter = 0;
      let isSingle = true;
      if (selectedDevices && selectedDevices.length > 0) {
        counter += selectedDevices.length;
        isSingle = selectedDevices.length === 1;
      }
      taskDialogRef.current.show(
        true,
        {
          title: `Messgerät${isSingle ? "" : "e"} schließen`,
          text: `
            ${isSingle ? "Das" : "Alle " + counter} ausgewählte ${isSingle ? "Messgerät wird" : "Messgeräte werden"} nun abgeschlossen.  
            Wollen Sie fortfahren?
          `,
          showTaskType: false,
        },
        () => closeDevices(selectedDevices),
      );
    },
    [selectedDevices, closeDevices, deviceTaskType],
  );

  const isExportable = selectedDevices && selectedDevices.length > 0;
  const isCloseable =
    isDeletionTask(deviceTaskType) &&
    selectedDevices &&
    selectedDevices.length > 0;
  return (
    <div className={className}>
      <div className="w3-cell-row">
        <div className="w3-cell w3-cell-middle pad-rht">
          <ActionFilter
            type="Device"
            taskType={deviceTaskType}
            setTaskType={filterDevices}
            itemsToCount={items}
            className="display-inline-block"
          />
        </div>
        <div className="w3-cell w3-cell-middle pad-lft">
          <W3Dropdown className="modems dropdown-list-menu">
            <W3DropdownToggler as={PrimaryButton} size="small-">
              {`Optionen`}
            </W3DropdownToggler>
            <W3DropdownContent
              className="w3-bar-block w3-border"
              style={{ right: "0", width: "280px" }}
            >
              <ButtonLink
                to="#"
                className="w3-bar-item dropdown-list-menu-item bg-secondary-hover"
                onClick={onExport}
                disabled={!isExportable}
              >
                {`Messgeräte exportieren (CSV)`}
              </ButtonLink>
              <ButtonLink
                className="w3-bar-item dropdown-list-menu-item bg-secondary-hover"
                to={`/wizard/aufgabe/import/device`}
                disabled={false}
              >
                {`Messgeräte importieren (CSV)`}
              </ButtonLink>
              <a href="#" className="w3-bar-item separator">
                <div className="w3-border-top" style={{ margin: "0 -4px" }} />
              </a>
              <ButtonLink
                to="#"
                className="w3-bar-item dropdown-list-menu-item bg-secondary-hover"
                onClick={onClose}
                disabled={!isCloseable}
              >
                {`Messgeräte schließen`}
              </ButtonLink>
            </W3DropdownContent>
          </W3Dropdown>
        </div>
      </div>
      <ConfirmationDialog ref={taskDialogRef} />
    </div>
  );
}

DeviceTaskMenu.propTypes = {
  className: PropTypes.string,
  selectedDevices: PropTypes.array,
  deviceTaskType: PropTypes.string,
  exportDevices: PropTypes.func.isRequired,
  items: PropTypes.array,
  history: PropTypes.object,
};
